// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"mystylearrowbuttons_buttonWrapper__IEMTp","commonBtnStyles":"mystylearrowbuttons_commonBtnStyles__ZbDsW","btnText":"mystylearrowbuttons_btnText__RRX1H"};